import styled from 'styled-components';
import { TEAM_SPACE_TABS } from '../team-space.consts';
import { LBTabs, LBTabsList, LBTabsTrigger } from '@linearb/buzz';

const StyledTeamSpaceTabs = styled.div``;

const tabs = [
  { value: TEAM_SPACE_TABS.CURRENT, name: 'Current' },
  { value: TEAM_SPACE_TABS.COMPLETED, name: 'Completed' },
  { value: TEAM_SPACE_TABS.TREND, name: 'Trends' }
];

const TeamSpaceTabs = ({ value, onChange }) => {
  return (
    <StyledTeamSpaceTabs>
      <LBTabs value={value} onValueChange={onChange}>
        <LBTabsList>
          {tabs.map(tab => (
            <LBTabsTrigger key={tab.value} value={tab.value}>
              {tab.name}
            </LBTabsTrigger>
          ))}
        </LBTabsList>
      </LBTabs>
    </StyledTeamSpaceTabs>
  );
};

export default TeamSpaceTabs;
